import { IDocumentFolderModel, IExternalLinkModel } from '@api/models';
import { moveExternalLinkToFolder } from '@api/services/document.service';
import { useMemo } from 'react';
import MoveItemDrawer from '../MoveItemDrawer/MoveItemDrawer';

interface MoveExternalLinkDrawerProps {
    clientId: string;
    folders: IDocumentFolderModel[];
    selectedExternalLink: IExternalLinkModel;
    show: boolean;
    onClose: () => void;
    refetchAll: () => void;
}

const MoveExternalLinkDrawer = ({
    clientId,
    folders,
    selectedExternalLink,
    show,
    onClose,
    refetchAll,
}: MoveExternalLinkDrawerProps) => {
    const initialLocation = useMemo(
        () => (selectedExternalLink?.folder ?? null) as string | null,
        [selectedExternalLink]
    );

    return (
        <MoveItemDrawer
            show={show}
            onClose={onClose}
            refetchAll={refetchAll}
            title="Move External Link"
            itemName={selectedExternalLink?.name}
            folders={folders}
            initialLocation={initialLocation}
            currentLocationParentId={initialLocation}
            initialBrowseParentId={initialLocation}
            successMessage="Link moved successfully."
            onMove={(destinationParentId) =>
                moveExternalLinkToFolder(clientId, selectedExternalLink._id, {
                    folder: destinationParentId,
                })
            }
        />
    );
};

export default MoveExternalLinkDrawer;
